import { effect as T, freeEnv as F } from "@matechs/effect";
export const consoleURI = "@matechs/console/consoleURI";
const Console_ = F.define({
    [consoleURI]: {
        assert: F.fn(),
        time: F.fn(),
        clear: F.cn(),
        info: F.fn(),
        count: F.fn(),
        countReset: F.fn(),
        debug: F.fn(),
        dir: F.fn(),
        dirxml: F.fn(),
        error: F.fn(),
        group: F.fn(),
        groupCollapsed: F.fn(),
        groupEnd: F.cn(),
        log: F.fn(),
        table: F.fn(),
        timeEnd: F.fn(),
        timeLog: F.fn(),
        trace: F.fn(),
        warn: F.fn()
    }
});
export const Console = F.opaque()(Console_);
export const provideConsole = F.implement(Console)({
    [consoleURI]: {
        assert: (v, m, ...o) => T.sync(() => console.assert(v, m, ...o)),
        clear: T.sync(() => console.clear()),
        count: (l) => T.sync(() => console.count(l)),
        countReset: (l) => T.sync(() => console.countReset(l)),
        debug: (m, ...o) => T.sync(() => console.debug(m, ...o)),
        dir: (ob, op) => T.sync(() => console.dir(ob, op)),
        dirxml: (...d) => T.sync(() => console.dirxml(...d)),
        error: (m, ...o) => T.sync(() => console.error(m, ...o)),
        group: (...l) => T.sync(() => console.group(...l)),
        groupCollapsed: (...l) => T.sync(() => console.groupCollapsed(...l)),
        groupEnd: T.sync(() => console.groupEnd()),
        info: (m, ...o) => T.sync(() => console.info(m, ...o)),
        log: (m, ...o) => T.sync(() => console.log(m, ...o)),
        table: (t, p) => T.sync(() => console.table(t, p)),
        time: (l) => T.sync(() => console.time(l)),
        timeEnd: (l) => T.sync(() => console.timeEnd(l)),
        timeLog: (l, ...d) => T.sync(() => console.timeLog(l, ...d)),
        trace: (m, ...o) => T.sync(() => console.trace(m, ...o)),
        warn: (m, ...o) => T.sync(() => console.warn(m, ...o))
    }
});
export const { [consoleURI]: { assert, time, clear, info, count, countReset, debug, dir, dirxml, error, group, groupCollapsed, groupEnd, log, table, timeEnd, timeLog, trace, warn } } = F.access(Console);
